import "../Styles/footer.css"

function Footer() {
  return (
    <div className="footer">
      <div className="content-container">
      <p>Meals 4 NYC®</p>
      </div>
      
      </div>
  )
}

export default Footer